import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const CardRoot = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	background: ${BTTO_PROFILE_COLORS.surface};
	border: 1px solid ${BTTO_PROFILE_COLORS.border};

	@media (min-width: 768px) {
		padding: 20px 24px;
		border-radius: 14px;
	}
`;

export const CardTitle = styled.h2`
	margin: 0 0 16px;
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 15px;
	font-weight: 600;
	line-height: 1.3;

	@media (min-width: 768px) {
		font-size: 16px;
		margin-bottom: 20px;
	}
`;

export const CardBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
